import { render } from "./VTestimonial.vue?vue&type=template&id=e54fae90"
import script from "./VTestimonial.vue?vue&type=script&lang=ts"
export * from "./VTestimonial.vue?vue&type=script&lang=ts"

import "./VTestimonial.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script